<script setup>
import { ref } from 'vue';
import { defineComponent } from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { INITIAL_EVENTS, createEventId } from './event-utils';
function handleWeekendsToggle() {
  calendarOptions.value.weekends = !this.calendarOptions.weekends; // update a property
}

function handleDateSelect(selectInfo) {
  let title = prompt('Please enter a new title for your event');
  let calendarApi = selectInfo.view.calendar;

  calendarApi.unselect(); // clear date selection

  if (title) {
    calendarApi.addEvent({
      id: createEventId(),
      title,
      start: selectInfo.startStr,
      end: selectInfo.endStr,
      allDay: selectInfo.allDay,
    });
  }
}

function handleEventClick(clickInfo) {
  if (
    confirm(
      `Are you sure you want to delete the event '${clickInfo.event.title}'`
    )
  ) {
    clickInfo.event.remove();
  }
}

function handleEvents(events) {
  currentEvents.value = events;
}

const calendarOptions = ref({
  plugins: [
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin, // needed for dateClick
  ],
  headerToolbar: {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay',
  },
  initialView: 'dayGridMonth',
  initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
  editable: true,
  selectable: true,
  selectMirror: true,
  dayMaxEvents: true,
  weekends: true,
  //select: handleDateSelect,
  // eventClick: handleEventClick,
  eventsSet: handleEvents,
  defaultTimedEventDuration: {
    days: 0,
  },
  allDaySlot: false,
});

const currentEvents = ref([]);
</script>
<style>
.calendar-app {
  width: 1500px;
  color: #333;
}
.calendar-app h2 {
  color: #333;
}

.fc-scrollgrid-sync-inner a {
  color: #333 !important;
}
</style>

<template>
  <div class="calendar-app">
    <FullCalendar :options="calendarOptions" />
  </div>
</template>
